import styled from 'styled-components'

import Spinner from 'shared/components/Spinner'
import { LinkCTA } from 'shared/components/Links'
import { colors, fonts } from 'shared/lib'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { t } from 'localization'

const TP = 'checkout.components.PromotionPanel.PromotionApplied'

const Promo = styled.div`
  border: 1px solid ${colors.FC2_BLACK};
  margin-bottom: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
`

const Title = styled.h4`
  ${fonts.SUBTITLE_3}
  margin: 0 0 3px;
`

const TextContainer = styled.div`
  flex: 1;
`

const BodyText = styled.div`
  ${fonts.BODY_TEXT}
  margin: 0;
`

const RemoveButton = styled(LinkCTA)`
  font-size: 12px;
`

const PromotionForm = () => {
  const { removePromotion, order, panels } = useCheckoutContext()
  const loading = panels.promotion.loading
  const orderNumber = order?.orderNumber
  const title = order?.promotion?.title
  const expiration = order?.promotion?.expiration
  return (
    <Spinner
      showSpinner={loading}
      text={loading ? t(`${TP}.spinnerText`, 'Removing promo...') : ''}
      subText={loading ? t(`${TP}.spinnerSubText`, 'Please do not close your browser!') : ''}
    >
      <Promo>
        <TextContainer>
          <Title>{title}</Title>
          <BodyText>{expiration}</BodyText>
        </TextContainer>
        <div>
          <RemoveButton
            qaAttr="removePromoButton"
            dataTestId="removePromoButton"
            color="grey"
            onClick={() => removePromotion(orderNumber)}
          >
            {t(`${TP}.remove`, 'Remove')}
          </RemoveButton>
        </div>
      </Promo>
      <BodyText>
        {t(
          `${TP}.bodyText`,
          'Limit one promotion per transaction. To apply a different promotion, remove the existing one.',
        )}
      </BodyText>
    </Spinner>
  )
}

export default PromotionForm
